export const visitRecordConstants = {
  // GET_ALL: 取得所有訪客紀錄
  GET_ALL_REQUEST: "VISIT_RECORD_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "VISIT_RECORD_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "VISIT_RECORD_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "VISIT_RECORD_RESET_ALL_SUCCESS",
  // EDIT_VISIT_RECORD: 建立訪客紀錄
  EDIT_VISIT_RECORD_REQUEST: "VISIT_RECORD_EDIT_VISIT_RECORD_REQUEST",
  EDIT_VISIT_RECORD_SUCCESS: "VISIT_RECORD_EDIT_VISIT_RECORD_SUCCESS",
  EDIT_VISIT_RECORD_FAILURE: "VISIT_RECORD_EDIT_VISIT_RECORD_FAILURE",
  RESET_EDIT_VISIT_RECORD_SUCCESS: "RESET_EDIT_VISIT_RECORD_SUCCESS",
  // GET_REASON_OPTIONS: 取得原因類型選項
  GET_REASON_OPTIONS_REQUEST: "VISIT_RECORD_GET_REASON_OPTIONS_REQUEST",
  GET_REASON_OPTIONS_SUCCESS: "VISIT_RECORD_GET_REASON_OPTIONS_SUCCESS",
  GET_REASON_OPTIONS_FAILURE: "VISIT_RECORD_GET_REASON_OPTIONS_FAILURE",
  RESET_REASON_OPTIONS_SUCCESS: "VISIT_RECORD_RESET_REASON_OPTIONS_SUCCESS",
};
